import React, { useState, useEffect } from 'react';
import { Modal, Button } from '../common';

function ManagerModal({ isOpen, onClose, onSubmit, initialData, mode = 'add' }) {
  const initialFormState = {
    user_id: '',
    user_pw: '',
    user_name: '',
    charge_work: ''
  };

  const [formData, setFormData] = useState(initialFormState);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (isOpen) {
      if (mode === 'edit' && initialData) {
        setFormData({
          id: initialData.id,
          user_id: initialData.user_id,
          user_name: initialData.user_name,
          charge_work: initialData.charge_work
        });
      } else {
        setFormData(initialFormState);
      }
      setError('');
      setSuccess('');
    }
  }, [isOpen, initialData, mode]);

  const validateInput = (value, fieldName) => {
    if (fieldName === 'user_pw') {
      return /^[A-Za-z\d!@#$%^&*()]{8,20}$/.test(value);
    }
    return /^[가-힣a-zA-Z0-9]{1,100}$/.test(value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    const fieldsToValidate = mode === 'edit' 
      ? Object.entries(formData).filter(([key, value]) => value !== initialData[key])
      : Object.entries(formData);

    if (mode === 'edit' && fieldsToValidate.length === 0) {
      setError('최소 하나의 필드를 수정해야 합니다.');
      return;
    }

    for (const [key, value] of fieldsToValidate) {
      if (!validateInput(value, key)) {
        if (key === 'user_pw') {
          setError('비밀번호는 8~20자의 영문, 숫자, 특수문자(!@#$%^&*())만 입력 가능합니다');
        } else {
          setError('필드는 1~100자의 한글, 영문, 숫자만 입력 가능합니다 (공백 및 특수문자 제외)');
        }
        return;
      }
    }

    try {
      const message = await onSubmit(formData);
      setSuccess(message);
      setTimeout(() => {
        handleClose();
      }, 1500);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleClose = () => {
    setError('');
    setSuccess('');
    setFormData(initialFormState);
    onClose();
  };

  const isFieldEditable = (fieldName) => {
    if (mode === 'add') return true;
    return initialData?.editField === fieldName;
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={mode === 'add' ? '관리자 추가' : '관리자 정보 수정'}
      size="md"
    >
      {!success ? (
        <>
          {error && <p className="mb-4 text-danger">{error}</p>}
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="mb-2 block">아이디</label>
              <input
                type="text"
                name="user_id"
                value={formData.user_id || ''}
                onChange={handleChange}
                className={`w-full rounded border px-3 py-2 ${mode === 'edit' ? 'bg-gray-100' : ''}`}
                disabled={mode === 'edit'}
                required={mode === 'add'}
              />
            </div>
            
            {mode === 'add' && (
              <div className="mb-4">
                <label className="mb-2 block">비밀번호</label>
                <input
                  type="password"
                  name="user_pw"
                  value={formData.user_pw || ''}
                  onChange={handleChange}
                  className="w-full rounded border px-3 py-2"
                  required
                />
              </div>
            )}

            <div className="mb-4">
              <label className="mb-2 block">이름</label>
              <input
                type="text"
                name="user_name"
                value={formData.user_name || ''}
                onChange={handleChange}
                className="w-full rounded border px-3 py-2"
                required
              />
            </div>

            <div className="mb-4">
              <label className="mb-2 block">담당 업무</label>
              <input
                type="text"
                name="charge_work"
                value={formData.charge_work || ''}
                onChange={handleChange}
                className="w-full rounded border px-3 py-2"
                required
              />
            </div>
            
            <div className="flex justify-end gap-2">
              <Button
                type="button"
                variant="secondary"
                onClick={handleClose}
              >
                취소
              </Button>
              <Button
                type="submit"
                variant="primary"
              >
                {mode === 'add' ? '추가' : '수정'}
              </Button>
            </div>
          </form>
        </>
      ) : (
        <div className="py-8 text-center">
          <p className="text-lg font-medium text-success">{success}</p>
        </div>
      )}
    </Modal>
  );
}

export default ManagerModal; 